import { render, staticRenderFns } from "./Popup.vue?vue&type=template&id=f42ba192&scoped=true&"
import script from "./Popup.vue?vue&type=script&lang=ts&"
export * from "./Popup.vue?vue&type=script&lang=ts&"
import style0 from "./index.scss?vue&type=style&index=0&id=f42ba192&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42ba192",
  null
  
)

export default component.exports